import { storageService } from './storage';
import i18n from '../locales';

const LANGUAGE_KEY = '@nebulatide:language';

/**
 * LanguageService
 * Regelt de taalinstellingen enzo
 */
class LanguageService {
  /**
   * Welke taal spreken we?
   * @returns Promise met 'nl' of 'en'
   */
  async getCurrentLanguage(): Promise<string> {
    try {
      const savedLanguage = await storageService.getItem(LANGUAGE_KEY);
      return savedLanguage || i18n.language || 'nl';
    } catch (error) {
      console.error('Fout bij ophalen huidige taal:', error);
      return i18n.language || 'nl';
    }
  }

  /**
   * Taal veranderen
   * Moet snel gaan (< 1 seconde) anders wordt de gebruiker gek
   * @param language - De taal code ('nl' of 'en')
   */
  async setLanguage(language: 'nl' | 'en'): Promise<void> {
    try {
      // Meteen aanpassen voor instant feedback (UX punten scoren)
      await i18n.changeLanguage(language);

      // Opslaan voor de volgende keer (asynchroon zodat de app niet vastloopt)
      storageService.setItem(LANGUAGE_KEY, language).catch(error => {
        console.error('Kon taal niet opslaan:', error);
      });
    } catch (error) {
      console.error('Fout bij instellen taal:', error);
      throw new Error('Kon taal niet instellen');
    }
  }

  /**
   * Welke talen hebben we?
   * Dit zijn de enige twee die we ondersteunen.
   */
  getSupportedLanguages(): string[] {
    return ['nl', 'en'];
  }

  /**
   * Hebben we al een taal opgeslagen?
   */
  async hasSavedLanguage(): Promise<boolean> {
    try {
      const savedLanguage = await storageService.getItem(LANGUAGE_KEY);
      return !!savedLanguage;
    } catch (error) {
      return false;
    }
  }

  /**
   * Opgeslagen taal inladen bij opstarten
   */
  async loadSavedLanguage(): Promise<void> {
    try {
      const savedLanguage = await storageService.getItem(LANGUAGE_KEY);
      if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'nl')) {
        await i18n.changeLanguage(savedLanguage);
      }
    } catch (error) {
      console.error('Fout bij laden opgeslagen taal:', error);
      // Geen ramp, dan pakken we wel de default (Engels wss)
    }
  }
}

export default new LanguageService();
